const FB_SDK_SCRIPT_ID = "facebook-jssdk";
const FB_SDK_SRC = "https://connect.facebook.net/en_US/sdk.js";

/** Injects the Facebook SDK once (safe if Settings and Ads both load it). */
export const loadFbSdk = () => {
  if (document.getElementById(FB_SDK_SCRIPT_ID)) {
    return;
  }
  const script = document.createElement("script");
  script.id = FB_SDK_SCRIPT_ID;
  script.src = FB_SDK_SRC;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
};

export const loadingMessageToText = (message: string) => {
  if (!message) {
    return null;
  }

  if (message.includes("CREATING_KYD_AUDIENCE")) {
    return "Creating KYD audience";
  }

  if (message.includes("CREATING_CUSTOM_AUDIENCE")) {
    return "Creating custom audience";
  }

  if (message.includes("PUBLISHING_ADSET")) {
    return "Publishing adset";
  }

  if (message.includes("CREATING_CAMPAIGN")) {
    return "Creating campaign";
  }

  if (message.includes("PUBLISHING_CAMPAIGN")) {
    return "Publishing campaign";
  }

  if (message.includes("UPDATING_CAMPAIGN")) {
    return "Updating campaign";
  }

  if (message.includes("UPDATING_ADSET")) {
    return "Updating adset";
  }

  if (message.includes("CREATING_ADSET")) {
    return "Creating adset";
  }

  if (message.includes("CREATING_AD_CREATIVE")) {
    return "Creating ad creative";
  }

  if (message.includes("UPDATING_AD")) {
    return "Updating ad";
  }

  if (message.includes("CREATING_AD")) {
    return "Creating ad";
  }

  if (message.includes("CREATING_PAGE_LOOKALIKE_AUDIENCE")) {
    return "Creating audiences";
  }

  if (message.includes("POPULATING_AUDIENCE")) {
    return "Populating audience";
  }

  return message;
};
